import { useState, type ReactNode, type SyntheticEvent } from "react";
import { LockKeyhole, Network } from "lucide-react";
import { useAuth } from "./AuthContext";

export function AuthGate({ children }: { children: ReactNode }) {
  const { authenticated, signIn } = useAuth();
  const [key, setKey] = useState("");
  const [remember, setRemember] = useState(false);
  if (authenticated) return children;

  function submit(event: SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    const normalized = key.trim();
    if (normalized) signIn(normalized, remember);
  }

  return (
    <main className="auth-layout">
      <section className="auth-intro" aria-labelledby="auth-title">
        <div className="brand-mark">
          <Network size={22} aria-hidden="true" />
        </div>
        <p className="eyebrow">Personal Agent gateway</p>
        <h1 id="auth-title">Synapse Control</h1>
        <p>Inspect routes, govern access, and operate durable Agent tasks from one local plane.</p>
        <div className="auth-signal" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
        </div>
      </section>
      <form className="auth-form" onSubmit={submit}>
        <LockKeyhole size={20} aria-hidden="true" />
        <h2>Connect to this gateway</h2>
        <label htmlFor="master-key">Master key</label>
        <input
          id="master-key"
          type="password"
          autoComplete="current-password"
          value={key}
          onChange={(event) => setKey(event.target.value)}
          required
          autoFocus
        />
        <label className="check-row">
          <input
            type="checkbox"
            checked={remember}
            onChange={(event) => setRemember(event.target.checked)}
          />
          Keep in this browser session
        </label>
        <button className="primary-button" type="submit">
          Open control plane
        </button>
      </form>
    </main>
  );
}
